import api from "./api";

export const seoService = {
  // Get all SEO
  getAll: () =>
    api.get("/admin/seo").then((res) => res.data),

  // Get SEO by page
  getByPage: (page) =>
    api.get(`/admin/seo/${page}`).then((res) => res.data),

  // Create SEO
  create: (formData) =>
    api
      .post("/admin/seo", formData)
      .then((res) => res.data),

  // Update SEO
  update: (page, formData) =>
    api
      .put(`/admin/seo/${page}`, formData)
      .then((res) => res.data),

  // Delete SEO
  delete: (page) =>
    api
      .delete(`/admin/seo/${page}`)
      .then((res) => res.data),

  // Public SEO - later frontend/server rendering mein use hoga
  getPublic: (page) =>
    api
      .get(`/seo/${page}`)
      .then((res) => res.data),


      getRobots: () =>
  api
    .get("/admin/robots")
    .then((res) => res.data),

updateRobots: (content) =>
  api
    .put("/admin/robots", { content })
    .then((res) => res.data),
};
export default seoService;